import React from 'react';
import {
  EnvironmentOutlined,
  FieldTimeOutlined,
  FileExcelOutlined,
  GiftOutlined,
  KeyOutlined,
  LoginOutlined,
  SettingOutlined,
  ShopOutlined,
  ShoppingCartOutlined,
  ShoppingOutlined,
  TableOutlined,
  TagOutlined,
  TagsOutlined,
} from '@ant-design/icons';

export const PATHS = {
  AUTHENTICATION: {
    LOGIN: '/auth',
  },
  ORDERS: {
    LIST: '/orders',
    DELAYED_ORDERS: '/orders/delayed-orders',
    GIFT_CARD_ORDERS: '/orders/gift-cards-orders',
    STORE_ORDERS: '/orders/store-orders',
    MARKETPLACE_ORDERS: '/orders/marketplace-orders',
  },
  MENU: {
    LIST: '/vendor/brands/:brandId/menu/:menuId',
    SECTIONS: '/vendor/brands/:brandId/menu/:menuId/sections',
    RELATED_ITEMS: '/vendor/brands/:brandId/menu/:menuId/related-items',
  },
  VENDOR: {
    LIST: '/vendor',
    BRANDS: '/vendor/brands',
    BRANCHES: '/vendor/branches',
    SCHEDULES: '/vendor/schedule',
    REWARDS: '/vendor/rewards-program',
  },
  VOUCHERS: {
    LIST: '/vouchers',
    VOUCHERS_UPLOAD: '/vouchers/upload',
  },
  PRODUCTS: {
    LIST: '/products',
  },
  REPORTING: {
    LIST: '/reporting',
    CUSTOMERS: '/reporting/customers',
    CREDITS_ORDERS: '/reporting/credit-orders',
    REFERRALS: '/reporting/referrals',
    DAILY_ORDERS_REPORT: '/reporting/daily-order-reports',
    WEEKLY_ORDERS_REPORT: '/reporting/weekly-order-reports',
    MONTHLY_ORDERS_REPORT: '/reporting/monthly-order-reports',
    PRICE_CHANGE_REPORT: '/reporting/price-change-reports',
    STATUS_CHANGE_REPORT: '/reporting/status-change-reports',
    OPERATING_HOURS_CHANGE_REPORT: '/reporting/operating-hours-change-reports',
    BRANCH_OFFLINE_REPORT: '/reporting/branch-offline-reports',
    FINANCIAL: '/reporting/financial',
    ORDER_RATING: '/reporting/order-rating',
    MAINTENANCE_REQUESTS: {
      LIST: '/reporting/maintenance-requests',
      ASSESSMENT_REQUESTS: '/reporting/maintenance-requests/assessment-requests',
      SERVICE_REQUESTS: '/reporting/maintenance-requests/service-requests',
    },
    COFElYTICS: '/reporting/cofelytics-requests',
    SUBSCRIPTION: '/reporting/subscription',
  },
  AUTHORIZATION: {
    LIST: '/authorization',
    PERMISSIONS: '/authorization/permissions',
    ROLES: '/authorization/roles',
    GROUPS: '/authorization/groups',
    USERS: '/authorization/users',
  },
  SETTINGS: {
    LIST: '/settings',
    NEIGHBORHOODS: '/settings/neighborhoods',
    NOTIFICATIONS: '/settings/notifications',
    GENERAL_SETTINGS: '/settings/general-settings',
    CURRENCIES: '/settings/currencies',
    COUNTRIES: '/settings/countries',
    CITIES: '/settings/cities',
    BANNERS: '/settings/banners',
    LOYALTY_TIERS: '/settings/loyalty-tiers',
    ADDRESSES: '/settings/addresses',
    SIGN_UP_PROMO: '/settings/signup-promo',
    GIFT_CARDS: '/settings/gift-cards',
    GIFT_CARDS_COLLECTIONS: '/settings/gift-card-collections',
    GIFT_CARDS_TEMPLATES: '/settings/gift-card-templates',
    GIFT_CARDS_BATCHES: '/settings/gift-card-batches',
    GIFT_CARDS_CREATION: '/settings/gift-cards-creation',
    STORE_CATEGORIES: '/settings/categories',
    PICK_UP_LOCATIONS: '/settings/pickup-locations',
    SHIPPING_POLICY: '/settings/shipping-policy',
    STORE_HEADERS: '/settings/store-headers',
    CUSTOMER_GROUPS: '/settings/customer-groups',
    BANKS: '/settings/banks',
    BANK_CARDS: '/settings/bank-cards',
    BLOG_CATEGORIES: '/settings/blog-categories',
    BLOG_POSTS: '/settings/blog-posts',
    NEW_BRANDS: '/settings/new-brands',
    OTP_CODES: '/settings/otp-codes',
    PAIRED_DEVICES: '/settings/paired-devices',
    RATINGS: '/settings/ratings',
    SUBSCRIPTION_PACKAGES: '/settings/subscription-packages',
    TAGS: '/settings/tags',
    HOME_PAGE_MANAGEMENT: '/settings/home-page-management',
    EXPRESS_DELIVERY_DRIVER: '/settings/express-delivery-drivers',
  },
};

export const PAGES = [
  {
    key: 'authorization',
    name: 'Authorization',
    pages: [{ key: 'login', name: 'Login', path: PATHS.AUTHENTICATION.LOGIN, icon: <LoginOutlined /> }],
  },
  {
    key: 'orders',
    name: 'Orders',
    pages: [
      { key: 'orders', name: 'Orders', path: PATHS.ORDERS.LIST, icon: <ShoppingCartOutlined /> },
      { key: 'delayed_orders', name: 'DelayedOrders', path: PATHS.ORDERS.DELAYED_ORDERS, icon: <FieldTimeOutlined /> },
      {
        key: 'gift_card_orders',
        name: 'Gift Card Orders',
        path: PATHS.ORDERS.GIFT_CARD_ORDERS,
        icon: <GiftOutlined />,
      },
      { key: 'store_orders', name: 'Store Orders', path: PATHS.ORDERS.STORE_ORDERS, icon: <ShopOutlined /> },
      {
        key: 'marketplace_orders',
        name: 'Marketplace Orders',
        path: PATHS.ORDERS.MARKETPLACE_ORDERS,
        icon: <ShopOutlined />,
      },
    ],
  },
  {
    key: 'vendor',
    name: 'Vendor',
    pages: [
      { key: 'vendor', name: 'Vendor', path: PATHS.VENDOR.LIST, icon: <ShoppingOutlined /> },
      { key: 'brands', name: 'Brands', path: PATHS.VENDOR.BRANDS, icon: <TagOutlined /> },
      { key: 'branches', name: 'Branches', path: PATHS.VENDOR.BRANCHES, icon: <EnvironmentOutlined /> },
      { key: 'schedules', name: 'Schedules', path: PATHS.VENDOR.SCHEDULES },
      { key: 'rewards', name: 'Rewards', path: PATHS.VENDOR.REWARDS },
    ],
  },
  {
    key: 'vouchers',
    name: 'Vouchers',
    pages: [
      { key: 'vouchers', name: 'Vouchers', path: PATHS.VOUCHERS.LIST },
      { key: 'vouchers_upload', name: 'Vouchers Upload', path: PATHS.VOUCHERS.VOUCHERS_UPLOAD },
    ],
  },
  {
    key: 'reporting',
    name: 'Reporting',
    pages: [
      { key: 'products', name: 'Products', path: PATHS.PRODUCTS.LIST },
      { key: 'reporting', name: 'Reporting', path: PATHS.REPORTING.LIST },
      { key: 'customers', name: 'Customers', path: PATHS.REPORTING.CUSTOMERS },
      { key: 'credit_orders', name: 'Credit Orders', path: PATHS.REPORTING.CREDITS_ORDERS },
      { key: 'referrals', name: 'Referrals', path: PATHS.REPORTING.REFERRALS },
      { key: 'order_rating', name: 'Order Rating', path: PATHS.REPORTING.ORDER_RATING },
      { key: 'daily_order_reports', name: 'Daily Order Reports', path: PATHS.REPORTING.DAILY_ORDERS_REPORT },
      { key: 'weekly_order_reports', name: 'Weekly Order Reports', path: PATHS.REPORTING.WEEKLY_ORDERS_REPORT },
      { key: 'monthly_order_reports', name: 'Monthly Order Reports', path: PATHS.REPORTING.MONTHLY_ORDERS_REPORT },
      { key: 'price_change_reports', name: 'Price Change Reports', path: PATHS.REPORTING.PRICE_CHANGE_REPORT },
      { key: 'status_change_reports', name: 'Status Change Reports', path: PATHS.REPORTING.STATUS_CHANGE_REPORT },
      {
        key: 'operating_hours_change_reports',
        name: 'Operating Hours Change Reports',
        path: PATHS.REPORTING.OPERATING_HOURS_CHANGE_REPORT,
      },
      {
        key: 'branch_offline_reports',
        name: 'Branch Offline Reports',
        path: PATHS.REPORTING.BRANCH_OFFLINE_REPORT,
      },
      { key: 'financial', name: 'Financial', path: PATHS.REPORTING.FINANCIAL },
      { key: 'maintenance_requests', name: 'Maintenance Requests', path: PATHS.REPORTING.MAINTENANCE_REQUESTS.LIST },
      {
        key: 'assessment_requests',
        name: 'Assessment Requests',
        path: PATHS.REPORTING.MAINTENANCE_REQUESTS.ASSESSMENT_REQUESTS,
      },
      {
        key: 'service_requests',
        name: 'Service Requests',
        path: PATHS.REPORTING.MAINTENANCE_REQUESTS.SERVICE_REQUESTS,
      },
      { key: 'cofelytics', name: 'COFElytics', path: PATHS.REPORTING.COFElYTICS },
      { key: 'subscription', name: 'Subscription', path: PATHS.REPORTING.SUBSCRIPTION },
    ],
  },
  {
    key: 'authorization',
    name: 'Authorization',
    pages: [
      { key: 'authorization', name: 'Authorization', path: PATHS.AUTHORIZATION.LIST },
      { key: 'permissions', name: 'Permissions', path: PATHS.AUTHORIZATION.PERMISSIONS },
      { key: 'roles', name: 'Roles', path: PATHS.AUTHORIZATION.ROLES },
      { key: 'groups', name: 'Groups', path: PATHS.AUTHORIZATION.GROUPS },
      { key: 'users', name: 'Users', path: PATHS.AUTHORIZATION.USERS },
    ],
  },
  {
    key: 'settings',
    name: 'Settings',
    pages: [
      { key: 'settings', name: 'Settings', path: PATHS.SETTINGS.LIST },
      { key: 'neighborhoods', name: 'Neighborhoods', path: PATHS.SETTINGS.NEIGHBORHOODS },
      // { key: 'notifications', name: 'Notifications', path: PATHS.SETTINGS.NOTIFICATIONS },
      { key: 'general_settings', name: 'General Settings', path: PATHS.SETTINGS.GENERAL_SETTINGS },
      { key: 'currencies', name: 'Currencies', path: PATHS.SETTINGS.CURRENCIES },
      { key: 'countries', name: 'Countries', path: PATHS.SETTINGS.COUNTRIES },
      { key: 'cities', name: 'Cities', path: PATHS.SETTINGS.CITIES },
      { key: 'banners', name: 'Banners', path: PATHS.SETTINGS.BANNERS },
      { key: 'loyalty_tiers', name: 'Loyalty Tiers', path: PATHS.SETTINGS.LOYALTY_TIERS },
      { key: 'addresses', name: 'Addresses', path: PATHS.SETTINGS.ADDRESSES },
      { key: 'sign_up_promo', name: 'Sign Up Promo', path: PATHS.SETTINGS.SIGN_UP_PROMO },
      { key: 'gift_cards', name: 'Gift Cards', path: PATHS.SETTINGS.GIFT_CARDS },
      { key: 'gift_card_collections', name: 'Gift Card Collections', path: PATHS.SETTINGS.GIFT_CARDS_COLLECTIONS },
      { key: 'gift_card_templates', name: 'Gift Card Templates', path: PATHS.SETTINGS.GIFT_CARDS_TEMPLATES },
      { key: 'gift_card_batches', name: 'Gift Card Batches', path: PATHS.SETTINGS.GIFT_CARDS_BATCHES },
      { key: 'gift_cards_creation', name: 'Gift Cards Creation', path: PATHS.SETTINGS.GIFT_CARDS_CREATION },
      { key: 'store_categories', name: 'Store Categories', path: PATHS.SETTINGS.STORE_CATEGORIES },
      { key: 'pick_up_locations', name: 'Pick Up Locations', path: PATHS.SETTINGS.PICK_UP_LOCATIONS },
      { key: 'shipping_policy', name: 'Shipping Policy', path: PATHS.SETTINGS.SHIPPING_POLICY },
      { key: 'store_headers', name: 'Store Headers', path: PATHS.SETTINGS.STORE_HEADERS },
      { key: 'customer_groups', name: 'Customer Groups', path: PATHS.SETTINGS.CUSTOMER_GROUPS },
      { key: 'banks', name: 'Banks', path: PATHS.SETTINGS.BANKS },
      { key: 'bank_cards', name: 'Bank Cards', path: PATHS.SETTINGS.BANK_CARDS },
      { key: 'blog_categories', name: 'Blog Categories', path: PATHS.SETTINGS.BLOG_CATEGORIES },
      { key: 'blog_posts', name: 'Blog Posts', path: PATHS.SETTINGS.BLOG_POSTS },
      { key: 'new_brands', name: 'New Brands', path: PATHS.SETTINGS.NEW_BRANDS },
      { key: 'otp_codes', name: 'Otp Codes', path: PATHS.SETTINGS.OTP_CODES },
      { key: 'paired_devices', name: 'Paired Devices', path: PATHS.SETTINGS.PAIRED_DEVICES },
      { key: 'ratings', name: 'Ratings', path: PATHS.SETTINGS.RATINGS },
      { key: 'subscription_packages', name: 'Subscription Packages', path: PATHS.SETTINGS.SUBSCRIPTION_PACKAGES },
      { key: 'tags', name: 'Tags', path: PATHS.SETTINGS.TAGS },
      { key: 'home_', name: 'Home Configuration', path: PATHS.SETTINGS.HOME_PAGE_MANAGEMENT },
      {
        key: 'express_delivery_drivers',
        name: 'Express Delivery Drivers',
        path: PATHS.SETTINGS.EXPRESS_DELIVERY_DRIVER,
      },
    ],
  },
];

export const navBarItems = [
  {
    id: 'orders',
    name: 'Orders',
    type: 'subMenu',
    permissions: ['order:view'],
    icon: <ShoppingCartOutlined />,
    items: [
      {
        id: 'orders-list',
        name: 'Orders',
        link: PATHS.ORDERS.LIST,
        type: 'item',
        permissions: ['order:view'],
      },
      {
        id: 'delayed-orders',
        name: 'Delayed Orders',
        link: PATHS.ORDERS.DELAYED_ORDERS,
        type: 'item',
        permissions: ['order:view'],
      },
      {
        id: 'gift-cards-orders',
        name: 'Gift Card Orders',
        link: PATHS.ORDERS.GIFT_CARD_ORDERS,
        type: 'item',
        permissions: ['giftCardsOrders:view'],
      },
      {
        id: 'store-orders',
        name: 'Store Orders',
        link: PATHS.ORDERS.STORE_ORDERS,
        type: 'item',
        permissions: ['storeOrder:view'],
      },
      {
        id: 'marketplace-orders',
        name: 'Marketplace Orders',
        link: PATHS.ORDERS.MARKETPLACE_ORDERS,
        type: 'item',
        permissions: ['marketplaceOrders:view'],
      },
    ],
  },
  {
    id: 'vendor',
    name: 'Vendor',
    type: 'subMenu',
    permissions: ['brand:view'],
    icon: <ShopOutlined />,
    items: [
      {
        id: 'brands',
        name: 'Brands List',
        link: PATHS.VENDOR.BRANDS,
        type: 'item',
        permissions: ['brand:view'],
      },
      {
        id: 'branches',
        name: 'Branches List',
        link: PATHS.VENDOR.BRANCHES,
        type: 'item',
        permissions: ['brandLocation:view'],
      },
      {
        id: 'schedules',
        name: 'Schedules',
        link: PATHS.VENDOR.SCHEDULES,
        type: 'item',
        permissions: ['brandLocation:view'],
      },
      {
        id: 'rewards-program',
        name: 'Rewards',
        link: PATHS.VENDOR.REWARDS,
        type: 'item',
        permissions: ['rewards:view'],
      },
    ],
  },
  {
    id: 'vouchers',
    name: 'Vouchers',
    type: 'subMenu',
    permissions: ['voucher:view'],
    icon: <TagsOutlined />,
    items: [
      {
        id: 'voucher list',
        name: 'Vouchers List',
        link: PATHS.VOUCHERS.LIST,
        type: 'item',
        permissions: ['voucher:view'],
      },
      {
        id: 'vouchers-upload',
        name: 'Vouchers Upload',
        link: PATHS.VOUCHERS.VOUCHERS_UPLOAD,
        type: 'item',
        permissions: ['voucher:view'],
      },
    ],
  },
  {
    id: 'products',
    name: 'Products',
    link: PATHS.PRODUCTS.LIST,
    type: 'item',
    permissions: ['products:view'],
    icon: <TableOutlined />,
  },
  {
    id: 'reporting',
    name: 'Reporting',
    type: 'subMenu',
    permissions: ['reporting:access'],
    icon: <FileExcelOutlined />,
    items: [
      {
        id: 'customers',
        name: 'Customers',
        link: PATHS.REPORTING.CUSTOMERS,
        type: 'item',
        permissions: ['reporting:customers'],
      },
      {
        id: 'credit-orders',
        name: 'Credit Orders',
        link: PATHS.REPORTING.CREDITS_ORDERS,
        type: 'item',
        permissions: ['reporting:creditorders'],
      },
      {
        id: 'referrals',
        name: 'Referrals',
        link: PATHS.REPORTING.REFERRALS,
        type: 'item',
        permissions: ['reporting:referrals'],
      },
      {
        id: 'order-rating',
        name: 'Order Rating',
        link: PATHS.REPORTING.ORDER_RATING,
        type: 'item',
        permissions: ['reporting:orderrating'],
      },
      {
        id: 'subscription',
        name: 'Subscription Order',
        link: PATHS.REPORTING.SUBSCRIPTION,
        type: 'item',
        permissions: ['reporting:orderrating'],
      },
      {
        id: 'order-reports',
        name: 'Financial Reports',
        type: 'group',
        permissions: ['reporting:orders'],
        items: [
          {
            id: 'daily-order-reports',
            name: 'Daily Order Reports',
            link: PATHS.REPORTING.DAILY_ORDERS_REPORT,
            type: 'item',
            permissions: ['reporting:orders'],
          },
          {
            id: 'weekly-order-reports',
            name: 'Weekly Order Reports',
            link: PATHS.REPORTING.WEEKLY_ORDERS_REPORT,
            type: 'item',
            permissions: ['reporting:orders'],
          },
          {
            id: 'monthly-order-reports',
            name: 'Monthly Order Reports',
            link: PATHS.REPORTING.MONTHLY_ORDERS_REPORT,
            type: 'item',
            permissions: ['reporting:orders'],
          },
        ],
      },
      {
        id: 'care-team-reports',
        name: 'Care Team Reports',
        type: 'group',
        permissions: ['reporting:orders'],
        items: [
          {
            id: 'price-change-reports',
            name: 'Price Change Reports',
            link: PATHS.REPORTING.PRICE_CHANGE_REPORT,
            type: 'item',
            permissions: ['reporting:orders'],
          },
          {
            id: 'status-change-reports',
            name: 'Status Change Reports',
            link: PATHS.REPORTING.STATUS_CHANGE_REPORT,
            type: 'item',
            permissions: ['reporting:orders'],
          },
          {
            id: 'operating-hours-change-reports',
            name: 'Operating Hours Change Reports',
            link: PATHS.REPORTING.OPERATING_HOURS_CHANGE_REPORT,
            type: 'item',
            permissions: ['reporting:orders'],
          },
          {
            id: 'branch-offline-reports',
            name: 'Branch Offline Reports',
            link: PATHS.REPORTING.BRANCH_OFFLINE_REPORT,
            type: 'item',
            permissions: ['reporting:orders'],
          },
        ],
      },
      {
        id: 'cofelytics-reports',
        name: 'CofeLytics',
        type: 'group',
        permissions: ['reporting:orders'],
        items: [
          {
            id: 'cofelytics-requests',
            name: 'COFElytics Requests',
            link: PATHS.REPORTING.COFElYTICS,
            type: 'item',
            permissions: ['reporting:orders'],
          },
        ],
      },
      {
        id: 'maintenance-requests',
        name: 'Maintenance Requests',
        type: 'group',
        permissions: ['maintenanceRequests:view'],
        items: [
          {
            id: 'maintenance_requests',
            name: 'Maintenance Requests',
            link: PATHS.REPORTING.MAINTENANCE_REQUESTS.LIST,
            type: 'item',
            permissions: ['maintenanceRequests:view'],
          },
          {
            id: 'assessment_requests',
            name: 'Assessment Requests',
            link: PATHS.REPORTING.MAINTENANCE_REQUESTS.ASSESSMENT_REQUESTS,
            type: 'item',
            permissions: ['maintenanceRequests:view'],
          },
          {
            id: 'service_requests',
            name: 'Service Requests',
            link: PATHS.REPORTING.MAINTENANCE_REQUESTS.SERVICE_REQUESTS,
            type: 'item',
            permissions: ['maintenanceRequests:view'],
          },
        ],
      },
    ],
  },
  {
    id: 'authorization',
    name: 'Authorization',
    type: 'subMenu',
    permissions: ['authorization:view'],
    icon: <KeyOutlined />,
    items: [
      {
        id: 'permissions',
        name: 'Permissions',
        link: PATHS.AUTHORIZATION.PERMISSIONS,
        type: 'item',
        permissions: ['authorization:view'],
      },
      {
        id: 'roles',
        name: 'Roles',
        link: PATHS.AUTHORIZATION.ROLES,
        type: 'item',
        permissions: ['authorization:view'],
      },
      {
        id: 'groups',
        name: 'Groups',
        link: PATHS.AUTHORIZATION.GROUPS,
        type: 'item',
        permissions: ['authorization:view'],
      },
      {
        id: 'users',
        name: 'Users',
        link: PATHS.AUTHORIZATION.USERS,
        type: 'item',
        permissions: ['authorization:view'],
      },
    ],
  },
  {
    id: 'settings',
    name: 'Settings',
    type: 'item',
    permissions: ['settings:access'],
    link: PATHS.SETTINGS.LIST,
    icon: <SettingOutlined />,
  },
];
